import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingActions from './components/FloatingActions';
import useScrollReveal from './hooks/useScrollReveal';

import Home from './pages/Home';
import TreatmentDetail from './pages/TreatmentDetail';
import Prices from './pages/Prices';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function Layout({ children }) {
  useScrollReveal();

  return (
    <div className="flex flex-col min-h-screen bg-warm-beige text-espresso font-sans">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <FloatingActions />
      <Layout>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          
          {/* Treatment Detail Routes */}
          <Route path="/behandlinger/fedtfrysning" element={<TreatmentDetail fixedSlug="fedtfrysning" />} />
          <Route path="/behandlinger/ems-traening" element={<TreatmentDetail fixedSlug="ems-traening" />} />
          <Route path="/behandlinger/body-roll" element={<TreatmentDetail fixedSlug="body-roll" />} />
          <Route path="/behandlinger/:slug" element={<TreatmentDetail />} />

          {/* Direct Treatment Slugs */}
          <Route path="/fedtfrysning" element={<TreatmentDetail fixedSlug="fedtfrysning" />} />
          <Route path="/ems-traening" element={<TreatmentDetail fixedSlug="ems-traening" />} />
          <Route path="/body-roll" element={<TreatmentDetail fixedSlug="body-roll" />} />

          {/* Other Core Pages */}
          <Route path="/priser" element={<Prices />} />
          <Route path="/om-cryo-by-breum" element={<About />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* Status Pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </>
  );
}
